import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useQuery } from '@apollo/client';
import { MEMBERS_QUERY } from '@general/graphql/members.graph';

const useMembers = ids => {
    const { loading, error, data } = useQuery(MEMBERS_QUERY, { variables: { ids } });
    const [members, setMembers] = useState();

    useEffect(() => {
        if (!data) return;
        setMembers(data.members);
    }, [data]);

    return { members };
};

// useMembers.propTypes = {
//     prop: PropTypes.
// };

export default useMembers;
